import { Component, OnInit, Input, AfterViewInit, OnDestroy, NgZone } from '@angular/core';
import { ModalController } from '@ionic/angular';
import videojs from 'video.js';
import 'video.js/dist/video-js.css'; // Ensure the Video.js CSS is included

@Component({
  selector: 'app-player-modal',
  templateUrl: './player-modal.component.html',
  styleUrls: ['./player-modal.component.scss'],
})
export class PlayerModalComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() videoUrl: any;
  isSuperover = false;
  player: any;
  @Input() posterUrl: string = '';

  get playerPoster(): string {
    return this.posterUrl || (
      this.isSuperover
        ? 'assets/images/Video_banner_SuperOver.jpg'
        : 'assets/images/Video_banner.jpg'
    );
  }

  constructor(public modalController: ModalController) { }

  ngOnInit() {
    this.isSuperover = this.videoUrl?.includes('superover');
  }

  ngAfterViewInit() {
    const useNativePlayback = videojs.browser.IS_SAFARI || videojs.browser.IS_IOS;
    // Initialize Video.js after the view is initialized
    this.player = videojs('video-player', {
      poster: this.playerPoster,
      controls: true,
      autoplay: false,
      playsinline: true,
      preload: 'auto',
      fluid: true, // Make the player responsive
      techOrder: ['html5'], // Use the HTML5 tech stack
      html5: {
        vhs: {
          overrideNative: !useNativePlayback,
          withCredentials: false,
        },
        nativeAudioTracks: useNativePlayback,
        nativeVideoTracks: useNativePlayback,
      },
    });

    // Explicitly identify HLS streams for native playback and Video.js.
    if (this.videoUrl && this.videoUrl.includes('.m3u8')) {
      this.player.src({
        type: 'application/x-mpegURL',
        src: this.videoUrl
      });
    } else {
      this.player.src(this.videoUrl);
    }
  }

  ngOnDestroy() {
    // Dispose of the player when the component is destroyed
    if (this.player) {
      this.player.dispose();
    }
  }

  dismiss() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }
}
